// Set grau_escolaridade to single value (for radio button)
export const setGrauEscolaridade = (nivel: string) => {
  return nivel;
};

// Get fields to clear when unselecting a grade level
export const getClearedFieldsForUncheck = (nivel: string | string[]) => {
  // Handle both string and array inputs
  const nivelValue = Array.isArray(nivel) ? (nivel[0] || '') : (nivel || '');
  const clears: string[] = [];
  if (nivelValue === 'Médio técnico') clears.push('medio_tecnico_concluido');
  if (nivelValue === 'Superior' || nivelValue === 'Pós-graduado') clears.push('superior_concluido');
  return clears;
};
